import initializeWizardCommon from './initializewizardcommon.js';
import {onDOMContentLoaded} from '../../dom/events.js';
import paging from './paging.js';
import questionaire from './questionaire.js';

onDOMContentLoaded(function() {
    questionaire();
    initializeWizardCommon();
    paging.init();
});
